import { keysToCamelCase } from 'shared/utils/api'

export const adaptGetStripeOnboardingStatusResponse = keysToCamelCase
export const adaptGetStripeOnboardingUrlResponse = keysToCamelCase
export const adaptGetStripeDashboardUrlResponse = keysToCamelCase
